import { useCallback, useContext, useEffect } from 'react';
import cssClass from './SettingsSection.module.css';
import { RoadmapContext } from '../../../context/RoadmapContext';
import { emitCustomEvent } from '../../../utils/helper';
import { useParams } from 'react-router-dom';

/**
 * Creates a debounced function that delays invoking the provided function
 * until after the specified delay has elapsed since the last time it was called.
 *
 * @param {Function} func - The function to debounce.
 * @param {number} delay - The delay in milliseconds before executing the function.
 * @returns {Function} - A debounced version of the input function.
 *
 * @example
 * const debouncedSearch = debounce(() => console.log('Search API called'), 300);
 * window.addEventListener('input', debouncedSearch);
 */
function debounce(func, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), delay);
  };
}

export const SettingsSection = () => {

  const {roadmap_id} = useParams();

  const { roadmapTitle, setRoadmapTitle, roadmapDescription, setRoadmapDescription, roadmapLevel, setRoadmapLevel } = useContext(RoadmapContext);

  const updateRoadmap = (payload) => {
    emitCustomEvent('roadmap::update', payload);
  }
  
  const debouncedUpdate = useCallback(
      debounce((payload) => {
        
        updateRoadmap(payload);
      }, 500),
      [roadmap_id],
    );

  const handleChange = (event) => {
    const {name, value} = event.target;
    console.log(name, value);
    
    switch(name) {
      case "title":
        setRoadmapTitle(value);
        break;
      case "description":
        setRoadmapDescription(value);
        break;
      case "level":
        setRoadmapLevel(value);
        break;
    }
  }

  useEffect(() => {
    const payload = {
          r_title: roadmapTitle,
          r_desc: roadmapDescription,
          r_l: roadmapLevel,
        };
    debouncedUpdate(payload);
  }, [roadmapDescription, roadmapLevel]);

  return (
    <form className={cssClass['component-container']}>
      <div className={cssClass['section-head']}>Settings</div>
      <div className={cssClass['section-input-ct']}>
        <div className={cssClass['section-input-name']}>Roadmap Name</div>
        <input name="title" className={cssClass['section-input']} type="text" value={roadmapTitle} onChange={handleChange} />
      </div>
      <div className={cssClass['section-input-ct']}>
        <div className={cssClass['section-input-name']}>
          Roadmap Description
        </div>
        {/* <input className={cssClass['section-input']} type="text" /> */}
        <textarea
          name="description"
          className={`${cssClass['section-input']} ${cssClass['textarea']}`}
          id=""
          value={roadmapDescription} onChange={handleChange}
        ></textarea>
      </div>
      <div className={cssClass['section-input-ct']}>
        <div className={cssClass['section-input-name']}>Level</div>
        <select
          name="level"
          className={`${cssClass['section-input']} ${cssClass['select']}`}
          value={roadmapLevel} onChange={handleChange}
        >
          <option value="">Select Level</option>
          <option value="beginner">Beginner</option>
          <option value="intermediate">Intermediate</option>
          <option value="advanced">Advanced</option>
        </select>
      </div>
    </form>
  );
};
